if (!customElements.get('honey-new-arrivals')) {
  customElements.define('honey-new-arrivals', class HoneyNewArrivals extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.honey-new-arrivals__viewport');
      this.cards = [...this.querySelectorAll('[data-arrival-card]')];
      this.controls = this.querySelector('[data-arrivals-controls]');
      this.previous = this.querySelector('[data-arrivals-previous]');
      this.next = this.querySelector('[data-arrivals-next]');
      this.current = this.querySelector('[data-arrivals-current]');
      this.total = this.querySelector('[data-arrivals-total]');
      this.onScroll = this.update.bind(this);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.previous.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.viewport);
      this.update();
    }
    perPage() {
      if (matchMedia('(min-width: 990px)').matches) return 3;
      if (matchMedia('(min-width: 750px)').matches) return 2;
      return 1;
    }
    pages() { return Math.ceil(this.cards.length / this.perPage()); }
    activePage() {
      const first = this.cards.findIndex(card => card.offsetLeft + card.offsetWidth > this.viewport.scrollLeft + 2);
      return Math.min(this.pages(), Math.max(1, Math.floor(Math.max(0, first) / this.perPage()) + 1));
    }
    update() {
      const pages = this.pages();
      const show = pages > 1 && this.viewport.scrollWidth > this.viewport.clientWidth + 2;
      this.controls.hidden = !show;
      this.total.textContent = String(pages);
      const current = this.activePage();
      this.current.textContent = String(current);
      this.previous.disabled = current === 1;
      this.next.disabled = current === pages;
    }
    go(direction) {
      const targetPage = Math.min(this.pages(), Math.max(1, this.activePage() + direction));
      const targetIndex = Math.min(this.cards.length - 1, (targetPage - 1) * this.perPage());
      this.viewport.scrollTo({ left: this.cards[targetIndex].offsetLeft, behavior: 'smooth' });
      window.setTimeout(() => this.update(), 350);
    }
  });
}
